import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import PageSEO from "../components/PageSEO";
import { FileText, Shield, DollarSign, ArrowLeft, Users, Cookie } from "lucide-react";
import axios from "axios";
import { sanitizeCmsHtml } from "../utils/sanitizeCms";
import { BACKEND_URL } from '../config/api';
import './TermsPage.css';

const API = `${BACKEND_URL}/api`;

const TermsPage = () => {
  const navigate = useNavigate();
  const [terms, setTerms] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchTerms();
  }, []);

  const fetchTerms = async () => {
    try {
      const response = await axios.get(`${API}/terms/active`);
      setTerms(response.data);
    } catch (error) {
      console.error("Error fetching terms:", error);
    } finally {
      setLoading(false);
    }
  };

  // Function to render HTML content safely with sanitization
  const renderContent = (content) => {
    if (!content) return <p>No content available</p>;
    return <div dangerouslySetInnerHTML={{ __html: sanitizeCmsHtml(content) }} />;
  };

  if (loading) {
    return (
      <div className="terms-page">
        <div className="terms-container">
          <div className="loading-state">Loading terms...</div>
        </div>
      </div>
    );
  }

  return (
    <>
      <PageSEO
        title="Terms & Conditions"
        description="Read the taskeri® terms of service covering bookings, escrow payments, cancellations, hero and client responsibilities, and platform fees in Canada."
        path="/terms"
      />
    <div className="terms-page">
      <div className="terms-container">
        {/* Header */}
        <div className="terms-page-header">
          <button className="back-btn" onClick={() => navigate("/")}>
            <ArrowLeft size={18} />
            Back
          </button>
          <div className="terms-page-title">
            <h1>Terms & Conditions</h1>
            <p>Version {terms?.version || "1.0"}</p>
          </div>
        </div>

        {/* Sections */}
        <div className="terms-sections">
          {/* Terms of Service */}
          <section className="terms-section">
            <div className="section-icon-header">
              <FileText size={28} />
              <h2>Terms of Service</h2>
            </div>
            <div className="section-content">
              {renderContent(terms?.terms_of_service)}
            </div>
          </section>

          {/* Independent Contractor Agreement */}
          <section className="terms-section">
            <div className="section-icon-header">
              <Users size={28} />
              <h2>Independent Contractor Agreement</h2>
            </div>
            <div className="section-content">
              {renderContent(terms?.independent_contractor_agreement)}
            </div>
          </section>

          {/* Payment Terms */}
          <section className="terms-section">
            <div className="section-icon-header">
              <DollarSign size={28} />
              <h2>Payment Terms</h2>
            </div>
            <div className="section-content">
              {renderContent(terms?.payment_terms)}
            </div>
          </section>
        </div>

        {/* Links to Privacy & Cookie Policy */}
        <div className="terms-other-links">
          <p>For more information, please also review:</p>
          <div className="links-row">
            <a href="/privacy" className="policy-link">
              <Shield size={18} />
              Privacy Policy
            </a>
            <a href="/cookie-policy" className="policy-link">
              <Cookie size={18} />
              Cookie Policy
            </a>
          </div>
        </div>

        {/* Footer */}
        <div className="terms-page-footer">
          <p>Last updated: {new Date(terms?.created_at).toLocaleDateString()}</p>
          <button className="btn btn-primary" onClick={() => navigate("/")}>
            Return to Home
          </button>
        </div>
      </div>
    </div>
    </>
  );
};

export default TermsPage;
